export const errors = {
    name: "Loan name is required",
    partner: "Please select a partner",
    amount: "Loan amount is required",
    sector: "Please select a sector",
    expiryDate: "Expiry date is required "
  };